module.exports = __webpack_public_path__ + "static/media/ic_pagination_previous.f4ee94ad.svg";